"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTIVITY = exports.CUSTOMER_SUCCESS = exports.SALES = exports.MARKETING = exports.FINANCE = void 0;
var FINANCE = 'FINANCE';
exports.FINANCE = FINANCE;
var MARKETING = 'MARKETING';
exports.MARKETING = MARKETING;
var SALES = 'SALES';
exports.SALES = SALES;
var CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
exports.CUSTOMER_SUCCESS = CUSTOMER_SUCCESS;
var PRODUCTIVITY = 'PRODUCTIVITY';
exports.PRODUCTIVITY = PRODUCTIVITY;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/SuperCategory.js
// module id = 111
// module chunks = 209 210 211 212 213